import React from 'react';
import HeroPicture from '../../assets/images/hero.png';
import shapeTwo from '../../assets/images/shape/shape-2.svg';
import shapeThree from '../../assets/images/shape/shape-3.svg';
import shapeFour from '../../assets/images/shape/shape-4.svg';
import GetItOnPlayStore from '../../assets/images/PlayStore.png';
import GetItOnIzzyOnDroid from '../../assets/images/IzzyOnDroid.png';

function Hero({ className }) {
    return (
        <>
            <section className={`moelist-hero-area ${className || ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="moelist-hero-content">
                                <span>Welcome To MoeList</span>
                                <h1 className="moelist-title">
                                    Another unofficial Android MAL client
                                </h1>
                                <ul
                                    style={{
                                        display: 'flex',
                                        listStyle: 'none',
                                        justifyContent: 'flex-start',
                                    }}
                                >
                                    <li style={{ marginLeft: '-3%' }}>
                                        <img
                                            alt="Get it on Google Play"
                                            src={GetItOnPlayStore}
                                            width="100%"
                                            height="100%"
                                            onClick={() =>
                                                window.open(
                                                    'https://play.google.com/store/apps/details?id=com.axiel7.moelist',
                                                    '_blank'
                                                )
                                            }
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </li>
                                    <li style={{ marginLeft: '-3%' }}>
                                        <img
                                            alt="Get it on IzzyOnDroid"
                                            src={GetItOnIzzyOnDroid}
                                            width="100%"
                                            height="100%"
                                            onClick={() =>
                                                window.open(
                                                    'https://apt.izzysoft.de/fdroid/index/apk/com.axiel7.moelist',
                                                    '_blank'
                                                )
                                            }
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="moelist-hero-thumb">
                                <div
                                    className="thumb wow animated fadeInUp"
                                    data-wow-duration="2000ms"
                                    data-wow-delay="200ms"
                                >
                                    <img src={HeroPicture} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero-shape-1">
                    <img src={shapeTwo} alt="" />
                </div>
                <div className="hero-shape-2">
                    <img src={shapeThree} alt="" />
                </div>
                <div className="hero-shape-3">
                    <img src={shapeFour} alt="" />
                </div>
            </section>
        </>
    );
}

export default Hero;
